/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_Server_Trainer_Reply_TitleInputs */

const en_us2_push_server_trainer_reply_title = /** @type {(inputs: Push_Server_Trainer_Reply_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your trainer replied`)
};

const pt_br2_push_server_trainer_reply_title = /** @type {(inputs: Push_Server_Trainer_Reply_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu personal respondeu`)
};

const es_419_push_server_trainer_reply_title = /** @type {(inputs: Push_Server_Trainer_Reply_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu entrenador respondió`)
};

const pt_pt2_push_server_trainer_reply_title = /** @type {(inputs: Push_Server_Trainer_Reply_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O teu treinador respondeu`)
};

const fr_fr2_push_server_trainer_reply_title = /** @type {(inputs: Push_Server_Trainer_Reply_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton coach a répondu`)
};

const de_de2_push_server_trainer_reply_title = /** @type {(inputs: Push_Server_Trainer_Reply_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Coach hat geantwortet`)
};

const it_it2_push_server_trainer_reply_title = /** @type {(inputs: Push_Server_Trainer_Reply_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo coach ha risposto`)
};

/**
* | output |
* | --- |
* | "Your trainer replied" |
*
* @param {Push_Server_Trainer_Reply_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const push_server_trainer_reply_title = /** @type {((inputs?: Push_Server_Trainer_Reply_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Server_Trainer_Reply_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_push_server_trainer_reply_title(inputs)
	if (locale === "es-419") return es_419_push_server_trainer_reply_title(inputs)
	if (locale === "pt-PT") return pt_pt2_push_server_trainer_reply_title(inputs)
	if (locale === "fr-FR") return fr_fr2_push_server_trainer_reply_title(inputs)
	if (locale === "de-DE") return de_de2_push_server_trainer_reply_title(inputs)
	if (locale === "it-IT") return it_it2_push_server_trainer_reply_title(inputs)
	return en_us2_push_server_trainer_reply_title(inputs)
});
export { push_server_trainer_reply_title as "push-server.trainer_reply_title" }